import React from 'react'

const SvgContrastActive = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M12 4v16c-4.411 0-8-3.588-8-8s3.589-8 8-8zm0 18c5.514 0 10-4.485 10-10 0-5.514-4.486-10-10-10S2 6.486 2 12c0 5.515 4.486 10 10 10z' />
  </svg>
)

export default SvgContrastActive
